// HomeEmpty.js
// One calm line shown when a card has loaded but has nothing to show.
import React from "react";
import { Text, StyleSheet } from "react-native";

import { homeColors } from "../homeTheme";

const HomeEmpty = ({ text, isDarkMode = false }) => {
  const colors = homeColors(isDarkMode);
  return <Text style={[styles.text, { color: colors.textSecondary }]}>{text}</Text>;
};

const styles = StyleSheet.create({
  text: { fontSize: 13, textAlign: "center", paddingVertical: 12 },
});

export default HomeEmpty;
